module.exports = __webpack_public_path__ + "static/media/IMG_6962.d78a90f4.jpg";